import { QueryConfig } from "store/utils/query-config";

export const automationWorkflowsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["-initiatedAt"]
  }
};
